import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { Spin, Button, Card, Col, Input, Modal, Row, Select } from 'antd';
import EssentialIcon from '../../../../../common/icons/EssentialIcon';
import './LeadCard.css';
import { inject, observer } from 'mobx-react';
import { api } from '../../../../../services';

const Status = props => (
  <Row className="Status" type="flex">
    <div className={`circle ${props.status === props.currentStatus ? 'highlight' : ''}`}>
      <EssentialIcon type={props.currentStatus} />
    </div>
    <span>{props.label}</span>
  </Row>
);

const Option = Select.Option;

@withRouter
@inject('translationsStore', 'commonStore')
@observer
export default class LeadCard extends Component {
  constructor(props) {
    super(props);
    const { translationsStore } = this.props;
    this.defaultAddValues = {
      canSubmit: true,
      reason: 'done',
      reasonVisible: false,
      reasonValue: '',
    };
    this.state = {
      loading: false,
      loadingExport: false,
      modalVisible: false,
      modalOpenLeadVisible: false,
      inputCanSubmit: this.defaultAddValues.canSubmit,
      inputReason: this.defaultAddValues.reason,
      inputReasonVisible: this.defaultAddValues.reasonVisible,
      inputReasonValue: this.defaultAddValues.reasonValue
    };
  }

  onReasonChange = value => {
    if (value === 'other') {
      this.setState({ inputReasonVisible: true, inputReason: value }, () => {
        this.checkProcessing();
      });
    } else {
      this.setState({ inputReasonVisible: false, inputReason: value }, () => {
        this.checkProcessing();
      });
    }
  };

  onReasonChangeValue = e => {
    this.setState({ inputReasonValue: e.target.value }, () => {
      this.checkProcessing();
    });
  };

  checkProcessing = () => {
    const { translationsStore } = this.props;
    let { inputReason, inputReasonValue } = this.state;
    inputReasonValue = inputReason==='other' ? inputReasonValue : translationsStore.translate(`carView.LeadCard.modalClosing.enumReason.${inputReason}`);

    const inputCanSubmit = inputReasonValue !== '';
    this.setState({ inputCanSubmit });
  };

  closeLeadWithReason = () => {
    if (this.state.inputCanSubmit) {
      const { translationsStore, id: leadId } = this.props;
      let { inputReason, inputReasonValue } = this.state;
      inputReasonValue = inputReason==='other' ? inputReasonValue : translationsStore.translate(`carView.LeadCard.modalClosing.enumReason.${inputReason}`);
      this.closeLead(leadId, inputReasonValue);
    }
  };

  closeLead = (leadId, reason) => {
    this.setState({
      loading: true
    });
    api('closeLead', leadId, reason)
      .then(response => {
        this.setState(
          {
            loading: false,
            modalVisible: false,
            inputCanSubmit: this.defaultAddValues.canSubmit,
            inputReason: this.defaultAddValues.reason,
            inputReasonVisible: this.defaultAddValues.reasonVisible,
            inputReasonValue: this.defaultAddValues.reasonValue
          },
          this.onClosedLead
        );
      })
      .catch(error => {
        console.error(`error in communication with server`, error);
        this.setState({
          loading: false
        });
      });
  };

  onClosedLead = () => {
    const loc = this.props.history.location;
    this.props.history.replace('/reload');
    setTimeout(() => {
      this.props.history.replace(loc);
    });
    this.props.commonStore.loadDealersSummary();
  };

  exportLeadLifeCycle = () => {
    const { id } = this.props;
    this.setState({ loadingExport: true });

    api('exportLeadLifeCycle', id).then(response => {
      const exportFilename = 'leadlifecycle.csv';
      try {
        const blob = new Blob([response], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');

        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', exportFilename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        console.error(err);
      } finally {
        this.setState({ loadingExport: false });
      }
    });
  }

  openLead = () => {
    this.setState({
      loading: true
    });

    const { carId } = this.props;

    api('openLead', carId)
      .then(() => {
        this.setState(
          {
            loading: false,
            modalOpenLeadVisible: false,
          },
          this.onOpenedLead
        );
      })
      .catch(error => {
        console.error(`error in communication with server`, error);
        this.setState({
          loading: false
        });
      });
  };

  onOpenedLead = () => {
    const loc = this.props.history.location;
    this.props.history.replace('/reload');
    setTimeout(() => {
      this.props.history.replace(loc);
    });
    this.props.commonStore.loadDealersSummary();
  };

  render() {
    const { translationsStore, commonStore, style, id } = this.props;
    return (
      <Card className="LeadCard" style={style} id="LeadCard">
        <div className="header">
          <div>{translationsStore.translate('carView.LeadCard.title')}</div>
          {id ? (
            <Fragment>
              <Modal
                {...this.props}
                visible={this.state.modalVisible}
                onCancel={() => this.setState({ modalVisible: false })}
                onOk={this.closeLeadWithReason}
                title={translationsStore.translate('carView.LeadCard.modalClosing.title')}
                centered={true}
                footer={[
                  <Button key="ok" type="primary" loading={this.state.loading} onClick={this.closeLeadWithReason} disabled={!this.state.inputCanSubmit}>
                    OK
                  </Button>
                ]}
              >
                <Row style={{ marginBottom: 20 }}>
                  <Col span={6}>{translationsStore.translate('carView.LeadCard.modalClosing.labelReason')}</Col>
                  <Col span={18}>
                    <div style={{ display: 'flex' }}>
                      <Select defaultValue={this.state.inputReason} onChange={this.onReasonChange}>
                        <Option value="done">{translationsStore.translate('carView.LeadCard.modalClosing.enumReason.done')}</Option>
                        <Option value="refused">{translationsStore.translate('carView.LeadCard.modalClosing.enumReason.refused')}</Option>
                        <Option value="other">{translationsStore.translate('carView.LeadCard.modalClosing.enumReason.other')}</Option>
                      </Select>
                      {this.state.inputReasonVisible && (
                        <Input
                          value={this.state.inputReasonValue}
                          onChange={this.onReasonChangeValue}
                          placeholder={translationsStore.translate('carView.LeadCard.modalClosing.labelReason')}
                          style={{ marginLeft: 10 }}
                        />
                      )}
                    </div>
                  </Col>
                </Row>
              </Modal>
              <div style={{ display: 'flex' }}>
                {commonStore.dealer && commonStore.dealer.serviceManagerEnabled && (
                  <Spin spinning={this.state.loadingExport}>
                    <Button
                      style={{ marginRight: '5px'}}
                      disabled={this.state.loadingExport}
                      type="primary"
                      onClick={this.exportLeadLifeCycle}
                    >{translationsStore.translate('carView.exportLeadLifeCycle')}</Button>
                  </Spin>
                )}
                <Button style={{ marginTop: '2px' }} onClick={() => this.setState({ modalVisible: true })} loading={this.state.loading} type="primary">
                  {translationsStore.translate('carView.LeadCard.labelClose')}
                </Button>
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <Modal
                {...this.props}
                visible={this.state.modalOpenLeadVisible}
                onCancel={() => this.setState({ modalOpenLeadVisible: false })}
                onOk={this.openLead}
                title={translationsStore.translate('carView.LeadCard.modalOpening.title')}
                centered={true}
                footer={[
                  <Button key="cancel" type="warning" loading={this.state.loading} onClick={() => this.setState({ modalOpenLeadVisible: false })}>
                    {translationsStore.translate('carView.LeadCard.modalOpening.labelCancel')}
                  </Button>,
                  <Button key="ok" type="primary" loading={this.state.loading} onClick={this.openLead}>
                    OK
                  </Button>
                ]}
              >
                {translationsStore.translate('carView.LeadCard.modalOpening.sureYouWantToOpenALead')}
              </Modal>
              <div style={{ display: 'flex' }}>
                <Button style={{ marginTop: '2px' }} onClick={() => this.setState({ modalOpenLeadVisible: true })} loading={this.state.loading} type="primary">
                  {translationsStore.translate('carView.LeadCard.labelOpen')}
                </Button>
              </div>
            </Fragment>
          )}
        </div>
        <div>
          <Row type="flex" style={{ justifyContent: 'space-between' }}>
            <Row className="line" style={{ borderTop: '1px solid #BBBBBB' }} />
            <Status status={this.props.status} currentStatus="notified" label={translationsStore.translate('lead.status.notified')} />
            <Status status={this.props.status} currentStatus="sent" label={translationsStore.translate('lead.status.sent')} />
            <Status status={this.props.status} currentStatus="action" label={translationsStore.translate('lead.status.action')} />
            <Status status={this.props.status} currentStatus="booked" label={translationsStore.translate('lead.status.booked')} />
            <Status status={this.props.status} currentStatus="discarded" label={translationsStore.translate('lead.status.discarded')} />
            <Status status={this.props.status} currentStatus="suspended" label={translationsStore.translate('lead.status.suspended')} />
          </Row>
        </div>
      </Card>
    );
  }
}
